import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Modal } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import icon from "../assets/icons/ForgotPassword.png";
import loginIcon from "../assets/icons/LoginIcon.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { PhoneInput } from "react-international-phone";
import { getCountryCallingCode } from "react-phone-number-input";
import CountrySelect from "../utils/countrySelect";

/* ---------- Direction C tokens (styling only) — same as Login ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const MUTED = "#66748A";
const LINE = "#E4E9EF";
const FIELD_EDGE = "#D5DEE7";
const PRIMARY = "#0B5C8A";
const PRIMARY_DARK = "#084767";
const ERROR = "#C42B24";

// Same page layout / field styles as the Login screen
const LOGIN_CSS = `
.dc-login{position:relative;min-height:100dvh;display:grid;grid-template-columns:minmax(0,1.05fr) minmax(0,1fr);background:#FFFFFF;font-family:${FONT};color:${INK};text-align:left;box-sizing:border-box;}
.dc-login *{box-sizing:border-box;}
.dc-login.App{padding:0!important;margin:0!important;}

/* ---- brand panel ---- */
.dc-login .dc-brand{position:relative;overflow:hidden;display:flex;flex-direction:column;justify-content:space-between;padding:40px 48px;color:#FFFFFF;
  background:radial-gradient(120% 90% at 0% 0%, #13729F 0%, ${PRIMARY} 38%, #0A3F5E 72%, ${INK} 100%);}
.dc-login .dc-brand::before{content:"";position:absolute;inset:0;pointer-events:none;
  background-image:linear-gradient(rgba(255,255,255,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.06) 1px,transparent 1px);
  background-size:44px 44px;mask-image:radial-gradient(90% 80% at 30% 20%,#000 20%,transparent 75%);-webkit-mask-image:radial-gradient(90% 80% at 30% 20%,#000 20%,transparent 75%);}
.dc-login .dc-brand::after{content:"";position:absolute;width:520px;height:520px;right:-180px;bottom:-200px;border-radius:50%;
  background:radial-gradient(circle,rgba(47,168,100,.28),transparent 65%);pointer-events:none;}
.dc-login .dc-brand > *{position:relative;z-index:1;}
.dc-login .dc-feature{display:flex;gap:12px;align-items:flex-start;padding:12px 0;border-top:1px solid rgba(255,255,255,.12);}
.dc-login .dc-feature:first-child{border-top:0;}
.dc-login .dc-ico{flex:0 0 30px;width:30px;height:30px;border-radius:9px;display:flex;align-items:center;justify-content:center;
  background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.16);font-family:${MONO};font-size:12px;font-weight:600;}
.dc-login .dc-preview{margin-top:28px;max-width:420px;padding:14px;border-radius:14px;background:rgba(255,255,255,.08);
  border:1px solid rgba(255,255,255,.14);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);}
.dc-login .dc-bar{height:8px;border-radius:999px;background:rgba(255,255,255,.14);overflow:hidden;}
.dc-login .dc-bar > span{display:block;height:100%;border-radius:999px;}

/* ---- form panel ---- */
.dc-login .dc-panel{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 24px;background:#FFFFFF;}
.dc-login .border-container{width:100%!important;max-width:400px!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;
  background:transparent!important;border:0!important;border-radius:0!important;box-shadow:none!important;text-align:left!important;}
.dc-login form{width:100%!important;max-width:none!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;
  background:transparent!important;border:0!important;box-shadow:none!important;}
.dc-login label.dc-lbl{display:block!important;width:auto!important;margin:0 0 6px!important;font-family:${FONT}!important;font-size:12.5px!important;font-weight:600!important;color:${INK_2}!important;}

/* one field frame for phone + password: border, hover and focus ring */
.dc-login .dc-field{display:flex!important;align-items:center;width:100%!important;height:46px!important;margin:0 0 16px!important;padding:0!important;
  background:#F8FAFC!important;border:1px solid ${FIELD_EDGE}!important;border-radius:11px!important;overflow:hidden;position:relative;
  transition:border-color .15s, box-shadow .15s, background .15s;}
.dc-login .dc-field:hover{border-color:#B4C6DA!important;}
.dc-login .dc-field:focus-within{background:#FFFFFF!important;border-color:${PRIMARY}!important;box-shadow:0 0 0 4px rgba(11,92,138,.12)!important;}
.dc-login .dc-field input{flex:1 1 auto;min-width:0;width:auto!important;height:100%!important;margin:0!important;padding:0 14px!important;border:0!important;outline:none!important;
  background:transparent!important;box-shadow:none!important;font-family:${FONT}!important;font-size:14.5px!important;color:${INK}!important;}
.dc-login .dc-field input::placeholder{color:#8A97A8;opacity:1;}
.dc-login .dc-cc{flex:0 0 auto;display:flex;align-items:center;height:100%;padding:0 6px 0 12px;border-right:1px solid ${FIELD_EDGE};}
.dc-login .dc-cc *{font-family:${FONT}!important;font-size:14px!important;color:${INK};}
.dc-login .toggle-icon{position:static!important;flex:0 0 46px;width:46px;height:100%;display:flex!important;align-items:center;justify-content:center;
  cursor:pointer;color:#8A97A8;transform:none!important;}
.dc-login .toggle-icon:hover{color:${INK_2};}
.dc-login a.dc-link{font-family:${FONT};font-size:13px;font-weight:600;text-decoration:none;}
.dc-login a.dc-link:hover{text-decoration:underline;text-underline-offset:3px;}

/* ---- responsive: stack on tablets / phones ---- */
@media (max-width: 960px){
  .dc-login{grid-template-columns:minmax(0,1fr);background:#F4F7FA;}
  .dc-login .dc-brand{display:none;}
  .dc-login .dc-panel{background:transparent;padding:32px 16px;}
  .dc-login .dc-card{background:#FFFFFF;border:1px solid ${LINE};border-radius:18px;padding:28px 22px 24px;box-shadow:0 24px 48px -28px rgba(15,27,42,.28);}
  .dc-login .dc-mobile-logo{display:flex!important;}
}
`;

// The OTP modal renders outside the page (portal), so its fields get
// their own copy of the field styles under .dc-otp.
const OTP_CSS = `
.dc-otp{font-family:${FONT};color:${INK};text-align:left;}
.dc-otp *{box-sizing:border-box;}
.dc-otp label.dc-lbl{display:block!important;width:auto!important;margin:0 0 6px!important;font-family:${FONT}!important;font-size:12.5px!important;font-weight:600!important;color:${INK_2}!important;}
.dc-otp .dc-field{display:flex!important;align-items:center;width:100%!important;height:46px!important;margin:0!important;padding:0!important;
  background:#F8FAFC!important;border:1px solid ${FIELD_EDGE}!important;border-radius:11px!important;overflow:hidden;position:relative;
  transition:border-color .15s, box-shadow .15s, background .15s;}
.dc-otp .dc-field:hover{border-color:#B4C6DA!important;}
.dc-otp .dc-field:focus-within{background:#FFFFFF!important;border-color:${PRIMARY}!important;box-shadow:0 0 0 4px rgba(11,92,138,.12)!important;}
.dc-otp .dc-field.dc-err{border-color:${ERROR}!important;}
.dc-otp .dc-field.dc-err:focus-within{box-shadow:0 0 0 4px rgba(196,43,36,.12)!important;}
.dc-otp .dc-field input{flex:1 1 auto;min-width:0;width:auto!important;height:100%!important;margin:0!important;padding:0 14px!important;border:0!important;outline:none!important;
  background:transparent!important;box-shadow:none!important;font-family:${FONT}!important;font-size:14.5px!important;color:${INK}!important;}
.dc-otp .dc-field input.dc-otp-code{font-family:${MONO}!important;font-size:18px!important;letter-spacing:.35em!important;text-align:center;}
.dc-otp .dc-field input::placeholder{color:#8A97A8;opacity:1;letter-spacing:normal;}
.dc-otp .toggle-icon{position:static!important;flex:0 0 46px;width:46px;height:100%;display:flex!important;align-items:center;justify-content:center;cursor:pointer;color:#8A97A8;transform:none!important;}
.dc-otp .toggle-icon:hover{color:${INK_2};}
.dc-otp .password-field{width:100%!important;margin:0!important;padding:16px 0 0!important;}
.dc-otp .input-wrapper{width:100%!important;margin:0!important;padding:0!important;}
.dc-login .dc-field.dc-err{border-color:${ERROR}!important;}
`;

const errText = { display: "block", margin: "6px 0 0", fontFamily: FONT, fontSize: 12.5, fontWeight: 500, lineHeight: 1.4, color: ERROR };
const primaryBtn = {
  height: "48px !important",
  minHeight: "48px !important",
  margin: "0 !important",
  borderRadius: "11px !important",
  background: `${PRIMARY} !important`,
  color: "#FFFFFF !important",
  border: "0 !important",
  fontFamily: FONT,
  fontSize: 15,
  fontWeight: 700,
  textTransform: "none",
  boxShadow: "0 10px 22px -12px rgba(11,92,138,.7)",
  "&:hover": { background: `${PRIMARY_DARK} !important` },
  "&:active": { transform: "translateY(1px)" },
  "&.Mui-disabled": { opacity: 0.5, color: "#FFFFFF !important", boxShadow: "none" },
};

const STEPS = [
  { n: "01", t: "Enter your mobile number", d: "Use the number you log in with." },
  { n: "02", t: "Check your email for the OTP", d: "It may land in your spam folder. The code is valid for 5 minutes." },
  { n: "03", t: "Set a new password", d: "Then log in with your new password." },
];

const ForgotPassword = () => {
  const [data, setData] = useState({
    username: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const navigate = useNavigate();
  const [timer, setTimer] = useState(300);
  const [country, setCountry] = useState("IN");
  const location = useLocation();
  const [viewPass, setViewPass] = useState(false);

  const handleViewPass = () => setViewPass(!viewPass);

  useEffect(() => {
    let interval = null;

    if (isOtpModalOpen && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    // Clean up on modal close or unmount
    return () => clearInterval(interval);
  }, [isOtpModalOpen, timer]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setFieldErrors({ ...fieldErrors, [e.target.name]: "" });
  };

  const validateFields = () => {
    const errors = {};
    // if (!data.username.trim()) {
    //   errors.username = "Username is required.";
    // } else if (!/^[6-9]\d{9}$/.test(data.username)) {
    //   errors.username = "Invalid mobile number (must be 10 digits)";
    // }
    return errors;
  };

  //   const validatePassword = () => {
  //     if (!data.newPassword.trim()) return "Password is required.";
  //     if (data.newPassword.length < 6)
  //       return "Password must be at least 6 characters.";
  //     return "";
  //   };

  const handleSendOtp = async () => {
    const errors = validateFields();
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    try {
      await axios.get(
        // `${process.env.REACT_APP_BACKEND_URL}/auth/send-password-reset-otp?email=${getCountryCallingCode(country)}${data.username.replace(/\D/g, "")}`,
        `${process.env.REACT_APP_BACKEND_URL}/auth/send-password-reset-otp?email=${data.username.replace(/\D/g, "")}&countryCode=${getCountryCallingCode(country)}`,
      );
      setIsOtpModalOpen(true);
      setTimer(300);
    } catch (error) {
      setError(error.response?.data?.Exception || "Failed to send OTP.");
    }
  };

  const handleChangePassword = async () => {
    // const passwordError = validatePassword();
    // if (passwordError) {
    //   setFieldErrors({ ...fieldErrors, newPassword: passwordError });
    //   return;
    // }

    if (!otp.trim()) {
      setFieldErrors({ ...fieldErrors, otp: "OTP is required." });
      return;
    }

    if (!data?.newPassword.trim()) {
      setFieldErrors({ ...fieldErrors, newPassword: "Password is required." });
      return;
    }
    // else if (data?.newPassword.length < 6) {
    //   setFieldErrors({
    //     ...fieldErrors,
    //     newPassword: "Password must be at least 6 characters.",
    //   });
    //   return;
    // }

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/verify-otp-and-submit-new-password`,
        {
          // username:`${getCountryCallingCode(country)}${data.username.replace(/\D/g, "")}`,
          username: data.username.replace(/\D/g, ""),
          newPassword: data.newPassword,
          otp,
        },
      );
      setIsOtpModalOpen(false);
      navigate("/");
    } catch (error) {
      setError(error.response?.data?.Exception || "Failed to reset password.");
    }
  };

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const sec = (seconds % 60).toString().padStart(2, "0");
    return `${min}:${sec}`;
  };

  /* ---------- display helpers (no logic change) ---------- */
  const isOnboarding = location.pathname.includes("user-onboarding");
  const mismatch = data.newPassword !== data.confirmPassword;
  const submitDisabled = timer === 0 || data.newPassword !== data.confirmPassword;

  // Enter key = same action as the buttons
  const onMainSubmit = (e) => {
    e.preventDefault();
    handleSendOtp();
  };
  const onOtpSubmit = (e) => {
    e.preventDefault();
    if (!submitDisabled) handleChangePassword();
  };

  const errorBox = (msg) => (
    <span
      role="alert"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        margin: "14px 0 0",
        padding: "10px 12px",
        background: "#FBEDEB",
        border: "1px solid #F2CFCA",
        borderRadius: 10,
        fontFamily: FONT,
        fontSize: 13,
        fontWeight: 500,
        color: "#A6342A",
      }}
    >
      <span
        style={{
          flex: "0 0 18px",
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: ERROR,
          color: "#FFFFFF",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 12,
          fontWeight: 800,
        }}
      >
        !
      </span>
      {msg}
    </span>
  );

  return (
    <>
      <style>{LOGIN_CSS + OTP_CSS}</style>
      <div className="dc-login">
        {/* ================= BRAND PANEL (desktop) ================= */}
        <aside className="dc-brand" aria-hidden="true">
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 11,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,.12)",
                border: "1px solid rgba(255,255,255,.2)",
              }}
            >
              <img src={loginIcon} alt="" style={{ width: 20, height: 20, objectFit: "contain" }} />
            </div>
            <span style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-0.01em" }}>Real Estate CRM</span>
          </div>

          <div style={{ maxWidth: 460 }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                height: 28,
                padding: "0 12px",
                borderRadius: 999,
                background: "rgba(255,255,255,.1)",
                border: "1px solid rgba(255,255,255,.18)",
                fontFamily: MONO,
                fontSize: 11,
                fontWeight: 500,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
              }}
            >
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#5EE0A0" }} />
              {isOnboarding ? "Account setup" : "Account recovery"}
            </div>
            <h2 style={{ margin: "18px 0 12px", fontSize: 38, lineHeight: 1.12, fontWeight: 800, letterSpacing: "-0.035em", textWrap: "balance" }}>
              {isOnboarding ? "Set your password in three quick steps." : "Back into your account in three quick steps."}
            </h2>
            <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: "rgba(255,255,255,.78)", maxWidth: 420 }}>
              We'll send a one-time code to the email linked to your mobile number.
            </p>

            <div style={{ marginTop: 28, maxWidth: 420 }}>
              {STEPS.map((f) => (
                <div className="dc-feature" key={f.n}>
                  <span className="dc-ico">{f.n}</span>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700 }}>{f.t}</div>
                    <div style={{ marginTop: 2, fontSize: 13, lineHeight: 1.5, color: "rgba(255,255,255,.7)" }}>{f.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ fontSize: 12, color: "rgba(255,255,255,.55)" }}>
            © {new Date().getFullYear()} · All rights reserved
          </div>
        </aside>

        {/* ================= FORM PANEL ================= */}
        <main className="dc-panel">
          <Box className="border-container">
            <div className="dc-card">
              <form onSubmit={onMainSubmit} noValidate>
                <div
                  style={{
                    width: 64,
                    height: 64,
                    marginBottom: 18,
                    borderRadius: 18,
                    background: "#EAF2FB",
                    border: "1px solid #C9DEF3",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={icon} alt="Forgot Password Icon" style={{ width: 42, height: 42, objectFit: "contain" }} />
                </div>

                <Typography
                  variant="h4"
                  component="h1"
                  sx={{ m: 0, fontFamily: FONT, fontSize: { xs: 26, sm: 30 }, fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1.15, color: INK }}
                >
                  {isOnboarding ? "User Onboarding" : "Forgot Password"}
                </Typography>
                <Typography
                  component="p"
                  sx={{ mt: 1, mb: 3.5, fontFamily: FONT, fontWeight: 500, color: "#4A5A6E", fontSize: 14.5, lineHeight: 1.55, textWrap: "pretty" }}
                >
                  Enter your registered mobile number to{" "}
                  {isOnboarding ? "set" : "change"} your password
                </Typography>

                <label htmlFor="username" className="dc-lbl">Mobile number</label>
                <div className={`phone-container dc-field ${fieldErrors.username ? "dc-err" : ""}`} style={{ marginBottom: 0 }}>
                  <div className="dc-cc">
                    <CountrySelect value={country} onChange={(c) => setCountry(c)} />
                  </div>
                  <input
                    type="tel"
                    id="username"
                    name="username"
                    inputMode="numeric"
                    autoComplete="tel-national"
                    placeholder="Enter mobile number"
                    onChange={(e) =>
                      setData((prev) => ({ ...prev, username: e.target.value }))
                    }
                  />
                </div>
                {fieldErrors.username && <span style={errText}>{fieldErrors.username}</span>}

                {error && !isOtpModalOpen && errorBox(error)}

                <Box mt={3} mb={0}>
                  <Button className="btn-contained" type="submit" fullWidth sx={primaryBtn}>
                    Send OTP
                  </Button>
                  {!isOnboarding && (
                    <Typography component="div" sx={{ textAlign: "center", mt: 2.5, fontFamily: FONT, fontSize: 13.5, color: MUTED }}>
                      Remembered it?{" "}
                      <a href="/" className="dc-link" style={{ color: PRIMARY }}>
                        Back to login
                      </a>
                    </Typography>
                  )}
                </Box>
              </form>
            </div>
          </Box>
        </main>
      </div>

      {/* ================= OTP MODAL ================= */}
      <Modal
        open={isOtpModalOpen}
        onClose={() => setIsOtpModalOpen(false)}
        slotProps={{ backdrop: { sx: { background: "rgba(15,27,42,0.5)", backdropFilter: "blur(2px)" } } }}
      >
        <Box
          className="dc-otp"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100% - 32px)", sm: 420 },
            maxHeight: "92vh",
            overflowY: "auto",
            bgcolor: "#FFFFFF",
            boxShadow: "0 32px 64px -20px rgba(15,27,42,0.5)",
            p: { xs: "24px 20px 22px", sm: "28px 28px 24px" },
            borderRadius: "20px",
            outline: "none",
          }}
        >
          <form onSubmit={onOtpSubmit} noValidate>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, marginBottom: 20 }}>
              <div>
                <Typography sx={{ fontFamily: FONT, fontSize: 21, fontWeight: 800, letterSpacing: "-0.02em", color: INK, lineHeight: 1.2 }}>
                  Enter OTP
                </Typography>
                <Typography sx={{ mt: 0.75, fontFamily: FONT, fontSize: 13.5, lineHeight: 1.5, color: "#4A5A6E", textWrap: "pretty" }}>
                  Kindly check your email (including spam folder) for OTP.
                </Typography>
              </div>
              <span
                style={{
                  flex: "0 0 auto",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  height: 28,
                  padding: "0 10px",
                  borderRadius: 999,
                  background: timer > 0 ? "#FDF4E1" : "#FBEDEB",
                  border: `1px solid ${timer > 0 ? "#F3E0B4" : "#F2CFCA"}`,
                  color: timer > 0 ? "#8A5A08" : "#A6342A",
                  fontFamily: MONO,
                  fontSize: 12.5,
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
                title={timer > 0 ? "OTP valid for" : "OTP expired"}
              >
                {timer > 0 ? `⏱ ${formatTime(timer)}` : "Expired"}
              </span>
            </div>

            <label htmlFor="otp" className="dc-lbl">Verification code</label>
            <div className={`dc-field ${fieldErrors.otp ? "dc-err" : ""}`}>
              <input
                type="text"
                name="otp"
                id="otp"
                className="dc-otp-code"
                inputMode="numeric"
                autoComplete="one-time-code"
                placeholder="Enter OTP"
                onChange={(e) => setOtp(e.target.value)}
              />
            </div>
            {fieldErrors.otp && <span style={errText}>{fieldErrors.otp}</span>}
            {timer === 0 && (
              <div style={{ marginTop: 8, fontFamily: FONT, fontSize: 12.5, color: MUTED }}>
                Code expired.{" "}
                <a
                  href="#resend"
                  className="dc-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSendOtp();
                  }}
                  style={{ color: PRIMARY, fontWeight: 600, textDecoration: "none" }}
                >
                  Send a new OTP
                </a>
              </div>
            )}

            <div className="password-field">
              <label htmlFor="newPassword" className="dc-lbl">New password</label>
              <div className={`input-wrapper dc-field ${fieldErrors.newPassword ? "dc-err" : ""}`}>
                <input
                  type={viewPass ? "text" : "password"}
                  name="newPassword"
                  id="newPassword"
                  autoComplete="new-password"
                  placeholder="Enter new password"
                  onChange={handleChange}
                  className="styled-input"
                />
                <span
                  className="toggle-icon"
                  onClick={handleViewPass}
                  role="button"
                  aria-label={viewPass ? "Hide password" : "Show password"}
                  title={viewPass ? "Hide password" : "Show password"}
                >
                  {viewPass ? <VisibilityOffIcon sx={{ fontSize: 20 }} /> : <VisibilityIcon sx={{ fontSize: 20 }} />}
                </span>
              </div>
            </div>
            {fieldErrors.newPassword && <span style={errText}>{fieldErrors.newPassword}</span>}

            <div className="password-field">
              <label htmlFor="confirmPassword" className="dc-lbl">Confirm password</label>
              <div className={`input-wrapper dc-field ${mismatch ? "dc-err" : ""}`}>
                <input
                  type={viewPass ? "text" : "password"}
                  name="confirmPassword"
                  id="confirmPassword"
                  autoComplete="new-password"
                  placeholder="Re-enter new password"
                  onChange={handleChange}
                  className="styled-input"
                />
                {!mismatch && data.confirmPassword && (
                  <span style={{ flex: "0 0 46px", display: "flex", justifyContent: "center", color: "#2FA864", fontWeight: 800 }}>✓</span>
                )}
              </div>
            </div>
            {mismatch && <span style={errText}>Passwords do not match</span>}

            {error && errorBox(error)}

            <Button
              className="btn-contained"
              type="submit"
              fullWidth
              sx={{ ...primaryBtn, mt: "22px !important" }}
              disabled={submitDisabled}
            >
              {isOnboarding ? "Set password" : "Reset password"}
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default ForgotPassword;